import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";

export default function UploadHistory() {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const fetchLogs = async () => {
      const querySnapshot = await getDocs(collection(db, "competitionLogs"));
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setHistory(data);
    };
    fetchLogs();
  }, []);

  return (
    <div>
      <h2>📜 Upload History</h2>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ borderBottom: "1px solid #aaa" }}>Date</th>
            <th style={{ borderBottom: "1px solid #aaa" }}>Competition</th>
            <th style={{ borderBottom: "1px solid #aaa" }}>Uploaded By</th>
          </tr>
        </thead>
        <tbody>
          {history.map(log => (
            <tr key={log.id}>
              <td>{new Date(log.timestamp?.seconds * 1000).toLocaleDateString()}</td>
              <td>{log.summary}</td>
              <td>{log.uploadedBy}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
